/**
 * @generated SignedSource<<f98da4532551fe260f936663057c6004>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightEditGeneralInfo_flight$data = {
  readonly expired: boolean;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"FlightDetails_flight" | "FlightEditGeneralInfoDetails_flight">;
  readonly " $fragmentType": "FlightEditGeneralInfo_flight";
};
export type FlightEditGeneralInfo_flight$key = {
  readonly " $data"?: FlightEditGeneralInfo_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightEditGeneralInfo_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightEditGeneralInfo_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expired",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightEditGeneralInfoDetails_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightDetails_flight"
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "81d48bb71beb361421e1da45cc1d16e5";

export default node;
